import React from "react";
import { CCard, CCardBody } from "@coreui/react";
import Skeleton from "react-loading-skeleton";

const Skeletons = () => (
  <>
    <div
      className="dashboard-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: "20px",
        gridTemplateRows: "auto auto",
      }}
    >
      <div style={{ display: "grid", gap: "20px" }}>
        <CCard className="border-light">
          <CCardBody>
            <Skeleton height={30} width={150} />
            <Skeleton height={20} width={100} />
            <div className="d-flex justify-content-center">
              <Skeleton height={30} width={100} />
            </div>
          </CCardBody>
        </CCard>
        <CCard className="border-light">
          <CCardBody>
            <Skeleton height={30} width={150} />
            <Skeleton height={20} width={100} />
            <div className="d-flex justify-content-center">
              <Skeleton height={160} width="100%" />
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div style={{ display: "grid", gap: "20px" }}>
        <CCard className="border-light">
          <CCardBody>
            <Skeleton height={30} width={150} />
            <Skeleton height={20} width={100} />
            <div className="d-flex justify-content-center">
              <Skeleton height={400} width="100%" />
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div style={{ display: "grid", gap: "20px" }}>
        <CCard className="border-light">
          <CCardBody>
            <Skeleton height={30} width={200} />
            <Skeleton height={20} width={150} />
            <Skeleton height={400} width="100%" />
          </CCardBody>
        </CCard>
      </div>
      <div style={{ display: "grid", gap: "20px" }}>
        <CCard className="border-light">
          <CCardBody>
            <Skeleton height={30} width={200} />
            <Skeleton height={20} width={150} />
            <Skeleton height={400} width="100%" />
          </CCardBody>
        </CCard>
      </div>
    </div>
    <style jsx>{`
      @media (max-width: 768px) {
        .dashboard-grid {
          grid-template-columns: 1fr !important;
        }
        .dashboard-grid > div {
          grid-column: span 2 !important;
        }
        .border-light {
          margin: 0 !important;
          padding: 0 !important;
        }
      }
    `}</style>
  </>
);

export default Skeletons;